import React, { Component, useState, useEffect, useRef } from 'react';
import './Home.css';
import AboutCard from '../components/AboutCard';
import ServicesCard from '../components/ServicesCard';
import data from '../components/data';
import data2 from '../components/data2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import HamburgerMenu from '../components/HamburgerMenu';
import axios from "axios";
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';


export default function Home(){
    const [cards, setCard] = useState([]);
    const [services, setServices] = useState([]);
    const [isOpen, setOpen] = useState(false);
    const ref = useRef(null);
    const formData = useRef({});
    const message  = useRef({});
    const name = useRef(null);
    const email = useRef(null);
    const [formStatus, setFormStatus] =  useState('');
    
   
    const cardsArr = data.map((card) =>{
       return <AboutCard key={card.id} heading ={card.heading} body={card.body} />
    })

    const serviceArr = data2.map((card) =>{
        return <ServicesCard key={card.id} heading ={card.heading} body={card.body} image = {card.image}/>
     })
/*
//Whatsapp Cloud API
    async function sendMsg(e){
        e.preventDefault();
       
        let complete_message =`*📥 New enquiry www.vannholdings.co.za*\n*From :* ` + name.current.value + `\n` +
        `*Email :* ` + email.current.value + `\n` +
        `*Message :* ` + message.current.value

                axios.post(
            "https://graph.facebook.com/v21.0/563023733550366/messages?access_token=" + process.env.REACT_APP_WHATSAPP_TOKEN,
            {
              messaging_product: "whatsapp",
              to: process.env.REACT_APP_WHATSAPP_NUMBER,
               type: "text",
              text: { body: complete_message},
            },
          );
          setFormStatus("Message Sent!")
          
          setTimeout(function(){
            window.location.reload()
          }, 5000);
          
     }
*/

async function sendMsg(e){
     e.preventDefault();
   
    let complete_message =`Good day, <br> <br> <br>
    <strong>📥 New enquiry</strong> <br> From : ` + name.current.value + `<br>` +
    `Email : ` + email.current.value + `<br>` +
    `Message : ` + message.current.value + `<br> <br> <br> <br> <br>Thanks,`
    
    try {
    const response = await axios.post(process.env.REACT_APP_EMAILAPI, {
            "message" : complete_message,
        });

        console.log(response)
        setFormStatus("Message Sent!")
          
        setTimeout(function(){
          window.location.reload()
        }, 5000);
    } catch (error) {
       
    }
};


function hamburgerClick(){
        setOpen(!isOpen)
        ref.current = isOpen
    }

    useEffect(()=>{
        setServices(serviceArr);
        setCard(cardsArr);
    },[])

    return(
        
        <div className='wrapper'>
           
            <section id='landing-page'  className='landing-page'>
            <header className='landing-page-header'>
                <img className='header-logo' src='https://ik.imagekit.io/qwj4cqxdwl/2023/03/vann-holdings-low-resolution-logo-color-on-transparent-background-1-768x229.png?updatedAt=1712780244884' alt='logo' width='200px'></img>
                <FontAwesomeIcon id='hamburger' className='hamburger' icon={faBars} size='lg'  onClick={hamburgerClick}/>
               { ref.current ? <HamburgerMenu/> : <></>}
            <nav id='navigation' className='navigation'>
                
                <a href='#landing_page'>
                    HOME
                </a>
                <a href='#about-us'>
                    ABOUT US
                </a>
                <a href='#services'>
                    SERVICES
                </a>
                <a href='#contact-form'>
                    CONTACT
                </a>
            </nav>
            </header>
            <div className='landing-page-text'>
                <h3>
                Streamline Your Logistics With Vann Holdings Supply Chain And Logistics
                </h3>
              <motion.div
                layout

                whileInView={
                  {
                      x: [-300,  0],
                  transition: { duration: 2.5 },
                }}
                viewport={{once : true}}
                >
                <h1>
                Moving Your Business Forward
                </h1>
                </motion.div>
              
            </div>

            </section>

            <section id='about-us' className='about-us'>
                <header className='about-us-header'>
                    <div className='h1-group'>
                    <div className='line'></div><h1>About Us</h1>
                    </div>
                    <h3>VANN HOLDINGS SUPPLY CHAIN & LOGISTICS</h3>
                </header>
                <div className='about-us-content'>    
                    {cards}
                </div>
                <div className='about-us-values'>
                   <motion.div
                      layout

                      whileInView={
                        {
                            x: [-300,  0],
                        transition: { duration: 2.5 },
                      }}

                    className='team'>
                    <div className='about-us-tag'>
                    <h3>Team Work</h3>
                        <p>Committed to excellence and Efficiency</p>
                        </div>
                    </motion.div>
                    <div 
                    

                    className='about-us-values-column'>
                    <motion.div
                    layout

                    whileInView={
                      {
                          x: [300,  0],
                      transition: { duration: 2 },
                    }}
                    className='philosophy'>
                    <div className='about-us-tag'>
                        <h3>Philosophy</h3>
                        <p>Care and precision</p>
                        </div>
                        </motion.div>
                       
                      <motion.div
                         layout

                         whileInView={
                           {
                               x: [300,  0],
                           transition: { duration: 2.5 },
                         }} 
                       className='office'>
                        <div className='about-us-tag'>
                        <h3>Office</h3>
                        <p>Somewhere on earth</p>
                        </div>
                        
                    
                    </motion.div>
                    </div>
                </div>
            </section>

            <section id='services' className='services'>
            <header className='about-us-header'>
                    <div className='h1-group'>
                    <div className='line'></div><h1>Services</h1>
                    </div>
                    <h3>OUR SERVICES FOR CLIENTS</h3>
                </header>
                <div className='services-content'>
                    {services}
                </div>

            </section>

            <section id='contact-form' className='contact-form'>
                <h1>GET IN TOUCH</h1>
                <div className='contact-form-content'>

                    <form ref={formData}>
                        <label htmlFor="name" >Name</label>
                        <input id='name' type='text' name='name' ref={name} ></input>
                        <label htmlFor="email" >Email</label>
                        <input id='email' type='text' name='email' ref={email}></input>
                        <label htmlFor="message" >Enquiry / Message</label>
                        <textarea id='message' type='text' name='message' ref={message} ></textarea>
                        <button className='contact-form-button' onClick={sendMsg} onTouchEnd={sendMsg}>Submit</button>
                        <small>{formStatus}</small>
                    </form>
                    <div className='contact-form-address'>
                       
                        <p>
                            <h2>South Africa</h2>
                        Address : 43 Montrose Street
                        <br/>
                        Vorna Valley, Midrand
                        <br/>
                        Gauteng, 1685, South Africa
                        <br/>
                        +27 (62) 856-7686
                        <br/>
                        +27 01 745 7855
                        <br/>
                        vannholdings@gmail.com
                        </p>
                        <br/>
                         <h2>Zambia</h2>
                        <p>
                        Address : Plot No. 20/72
                        <br/>
                        Great North Road, Chazanda
                        <br/>
                        Lusaka, Zambia
                        <br/>
                        +260 573 259 484
                        <br/>
                        vannholdings@gmail.com
                        </p>
                        <br/>
                        <h2>Zimbabwe</h2>
                          <p>
                        Address : 100 Samuel Parirenyatwa
                        <br/>
                        Bulawayo, Zimbabwe
                        <br/>
                        +263 782 452 322
                        <br/>
                        vannholdings@gmail.com
                        </p>
                    </div>

                </div>
            </section>
            
            <footer>
                <div className='footer-content'>
                <div>
                    <h2>Services</h2>
                    <ul>
                        <li>Logistics</li>
                        <li>Supply Chain</li>
                    </ul>
                </div>

                <div>
                    <h2>Quick Links</h2>
                    <ul>
                        <li> 
                            <a href='#landing-page'>
                                Home
                            </a> 
                        </li>
                        <li>
                            <a href='#about-us'>
                                About Us
                            </a>
                        </li>
                        <li>
                            <a href='#services'>
                                Services
                            </a>
                        </li>
                        <li>
                            <a href='#contact-form'>
                                Contact
                            </a>
                        </li>
                        <li>
                        <a href='https://www.termsfeed.com/live/5cb6a05a-9c8f-4d65-9a76-321886634902'>Privacy Policy</a>
                        </li>
                        
                    </ul>
                </div>

                <div>
                    <h2>Contact</h2>
                    <ul>
                        <li>+27 (62) 856-7686</li>
                        <li>+27 01 745 7855</li>
                        <li>vannholdings@gmail.com</li>
                    </ul>
                </div>

                </div>
                

                <small>Copyright ©. All rights reserved | Powered By Berabyte Tech</small>
            </footer>
            

        </div>
        
    )
}